var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconNotifications = function SvgIconNotifications(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFE9A8"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11 1.833a1.375 1.375 0 0 1 1.375 1.375v.642a5.96 5.96 0 0 1 4.583 5.775v3.85l1.834 2.567v.916H3.208v-.916l1.834-2.567v-3.85A5.96 5.96 0 0 1 9.625 3.85v-.642A1.375 1.375 0 0 1 11 1.833M8.708 18.333h4.584a2.292 2.292 0 0 1-4.584 0"
  }))));
};
export default SvgIconNotifications;